import { getFullUrl } from 'hubspot-url-utils';
import { prefetchPage } from 'prefetcher/utils/prefetchPage';
import { Step } from '../../views/Step';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { getHublet } from '../../store/app/selectors';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { bulkSetSignupDataSkip } from '../../store/signup-data/action-creators';
import { Data } from '../../signup-data/DATA';
import { getShouldOverrideToGosu0002Variant } from '../../experiments/gosu0002/getShouldOverrideToVariant';

const getIsInCrmSetupExperimentVariant = state => {
  // TODO: remove getShouldOverrideToGosu0002Variant() check after running GOSU-0002 user testing
  return getIsActiveAndAssignedToVariant(state, ExperimentKeys.GOSU0002, [ExperimentParameterGroup.Variant]) || getShouldOverrideToGosu0002Variant();
};

export const BranchCrmSetup = {
  name: 'BranchCrmSetup',
  stateCheck: state => getIsInCrmSetupExperimentVariant(state),
  rebuildFlow: (flow, state, dispatch) => {
    // Prefetch crm setup resources
    const hubletUrl = getFullUrl('app', {
      hubletOverride: getHublet(state)
    });
    prefetchPage('growth-crm-setup-ui-prefetch', {
      url: hubletUrl
    });
    dispatch(bulkSetSignupDataSkip({
      // These will be set in Portal 53 and Demographics in
      // a downstream Onboarding app
      // https://git.hubteam.com/HubSpot/growth-crm-setup/blob/bf6fc032ddcc9026b6976f0278ea95a0410129f3/growth-crm-setup-ui/static/js/hooks/postSignupInfo.ts#L65
      [Data.HubInterest]: undefined
    }));
    return dispatch(FlowStateManager.removeSteps([Step.HubInterest]));
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};